<template>
  <div class="general main-top-margin">
    <v-tabs
      @change="changeTab"
      v-model="activeTab"
      background-color="transparent"
      color="#26262A"
      slider-color="#26262A"
      light
      :hide-slider="false"
      slider-size="2"
    >
      <v-tab><lang t="BUNDLE_GROUP-TAB-SETTINGS"></lang></v-tab>
      <v-tab><lang t="BUNDLE_GROUP-TAB-LIST"></lang></v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">

      <v-tab-item class="py-6 px-0">
        <tab-settings />
      </v-tab-item>

      <v-tab-item class="py-6 px-0">
          <tab-list />
      </v-tab-item>
    </v-tabs-items>


  </div>
</template>

<script>
import tabList from './bundleGroup-tab-list.vue';
import tabSettings from './bundleGroup-tab-settings.vue';

export default {

  components: {
    tabList,
    tabSettings,
    
  },

  data: () => ({
      isSaving: false,
      isLoading: true,
      activeTab: 0,
  }),

  watch: {

  },

  created() {
  },

  computed: {

  },

  methods: {

  },

}

</script>

<style lang="scss" scoped>

</style>
